import React from "react";
import { CLASS_STYLES } from "../../landingContent";
import SectionHeading from "../SectionHeading";
import DeferredLandingVideo from "../DeferredLandingVideo";

const ClassStylesSection = () => (
  <section className="landing-v2__section landing-v2-class-styles" aria-labelledby="class-styles-heading">
    <div className="landing-v2__container">
      <div className="landing-v2__split landing-v2-class-styles__layout">
        <div className="landing-v2__split-copy">
          <SectionHeading
            headline={CLASS_STYLES.headline}
            subheading={CLASS_STYLES.subheading}
            centered={false}
            headingId="class-styles-heading"
          />

          <ul className="landing-v2-class-styles__highlight-list">
            {CLASS_STYLES.highlights.map((highlight) => (
              <li key={highlight}>{highlight}</li>
            ))}
          </ul>
        </div>

        <figure className="landing-v2-class-styles__media-card">
          <div className="landing-v2-class-styles__media-frame">
            <DeferredLandingVideo
              src={CLASS_STYLES.videoSrc}
              poster={CLASS_STYLES.videoPoster}
              alt={CLASS_STYLES.imageAlt}
              className="landing-v2-class-styles__deferred-media"
            />
          </div>
          <figcaption>Class-level style presets and custom display options.</figcaption>
        </figure>
      </div>
    </div>
  </section>
);

export default ClassStylesSection;
